// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Drawer } from '@/ui';
import {
  StyledContentBlock,
  StyledHeaderBlock,
  StyledPageTitle,
  StyledPageWrapper,
  StyledCreateButton,
  StyledTabsWrap,
} from './PartnersListIndexContainerStyles';
import PartnersListContainer from '../PartnersListContainer/PartnersListContainer';
import { PlusCircleIcon } from '@/icons';
import { useForm } from '@/components';

// Models
import CreatePartnerContainer from '../CreatePartnerContainer/CreatePartnerContainer';

// Modules
import { usePermissions, Resource } from '@/modules/Permissions';

// Helpers
import { useBoolean } from '@/hooks';

const PartnersListIndexContainer = () => {
  const { t } = useTranslation(['partners']);
  const { value: createFormOpened, setFalse: closeCreateForm, setTrue: openCreateForm } = useBoolean();
  const [form] = useForm();
  const { canManage } = usePermissions();
  const canManagePartners = canManage(Resource.PARTNER);

  const onDrawerClose = () => {
    closeCreateForm();
    form.resetFields();
  };

  return (
    <StyledPageWrapper>
      <StyledHeaderBlock>
        <StyledPageTitle>{t('partners_title')}</StyledPageTitle>
        <StyledTabsWrap>
          {canManagePartners && (
            <StyledCreateButton onClick={openCreateForm}>
              <PlusCircleIcon />
              {t('partners_create_partner')}
            </StyledCreateButton>
          )}
        </StyledTabsWrap>
      </StyledHeaderBlock>
      <StyledContentBlock>
        <PartnersListContainer />
      </StyledContentBlock>
      <Drawer open={createFormOpened} onClose={onDrawerClose} width="min(660px, 100vw)">
        <CreatePartnerContainer form={form} onFormSubmit={onDrawerClose} />
      </Drawer>
    </StyledPageWrapper>
  );
};

export default PartnersListIndexContainer;
